<div class="row registerCards">
  <div class="card lift" *ngFor="let ndcRegistrationCard of ndcRegistrationCards">
    <div class="inner-container miHi-4">
      <div class="card-image-header show-image imageW" style="background-image: url('{{ ndcRegistrationCard.headImage }}');"></div>
      <div class="card-body">
        <div class="card-content">
          <app-note *ngIf="ndcRegistrationCard.noteSections?.length" [noteSections]="ndcRegistrationCard.noteSections || []"> </app-note>
          <h3 class="card-title smaller-linespace">{{ ndcRegistrationCard.title.split('#')[0] }}</h3>
          <h3 class="card-title smaller-linespace">{{ ndcRegistrationCard.title.split('#')[1] }}</h3>
          <p [innerHTML]="ndcRegistrationCard.body || '' | mdToHtml" class="card-text"></p>
        </div>
      </div>
    </div>
    <div class="button-center">
      <a class="ba-btn" [href]="ndcRegistrationCard.buttonUrl" role="button" [target]="ndcRegistrationCard.buttonUrl === '/orderChangeNotif/register' || ndcRegistrationCard.buttonUrl === '/iagportal/Where%20do%20I%20register' ? '' : '_blank'"> {{ ndcRegistrationCard.buttonText }}</a>
    </div>
  </div>
</div>
